<template>
  <div class="increase-edit-padding">
    <a-spin :spinning="loading">
      <a-skeleton v-show="loading" :paragraph="{rows: 10}" />
    </a-spin>
    <div v-show="!loading">
      <!-- 表单 -->
      <a-form :form="editForm" @submit="handleSubmit" autocomplete="off">
        <!-- 国家 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Country"
        >
          <a-select
            @change="handelCountryChange"
            v-decorator="[
              'countryId',
              { rules: [{ required: true, message: 'Please select your Country!' }] },
            ]"
            placeholder="Please select your Country"
          >
            <a-select-option value="">No Select</a-select-option>
            <a-select-option v-for="c in countries" :key="c.id" :value="c.id">{{ c.nameEnUs }}</a-select-option>
          </a-select>
        </a-form-item>
        <!-- 国家 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="State/Province"
        >
          <a-select
            v-decorator="[
              'stateId',
              { rules: [{ required: true, message: 'Please select your State!' }] },
            ]"
            placeholder="Please select your State"
          >
            <a-select-option value="">No Select</a-select-option>
            <a-select-option v-for="c in stateList" :key="c.id" :value="c.id">{{ c.nameEnUs }}</a-select-option>
          </a-select>
        </a-form-item>
        <!-- 代码 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Code"
        >
          <a-input
            placeholder="Code"
            v-decorator="[
              'code',
              {rules: [{ required: true, message: 'Please input Code.' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 名称-英文美国 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Name(en-us)"
        >
          <a-input
            placeholder="Name(en-us)"
            v-decorator="[
              'nameEnUs',
              {rules: [{ required: true, message: 'Please input Name.' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 名称-中文繁体 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Name(zh-tw)"
        >
          <a-input
            placeholder="Name(zh-tw)"
            v-decorator="[
              'nameZhTw',
              {rules: [{ required: false, message: 'Please input Name.' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 名称-中文简体 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Name(zh-cn)"
        >
          <a-input
            placeholder="Name(zh-cn)"
            v-decorator="[
              'nameZhCn',
              {rules: [{ required: false, message: 'Please input Name.' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 启用标志 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Eabled"
        >
          <a-switch
            v-decorator="[
              'enabledFlag',
              { valuePropName: 'checked' }
            ]"
          ></a-switch>
        </a-form-item>
        <!-- 排序 -->
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="Sort No."
        >
          <a-input-number :min="0" :max="10000" v-decorator="[ 'sortNum']" />
        </a-form-item>
        <!-- 隐藏域 -->
        <a-form-item v-show="false"><a-input
          v-decorator="[
          'id',
          {rules: [{ required: false}]}
          ]"/>
        </a-form-item>
      </a-form>
    </div>
    <footer-tool-bar>
      <a-button type="primary" html-type="submit" :loading="saving" @click="handleSubmit">Save</a-button>
      <a-button style="margin-left: 8px;" :loading="saving" @click="handleGoBack">Cancel</a-button>
    </footer-tool-bar>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import CityApi from '@/api/basicdata/api-city'
import CountryApi from '@/api/basicdata/api-country'
import StateApi from '@/api/basicdata/api-state'
import FooterToolBar from '@/components/FooterToolbar'

export default {
  name: 'CityEdit',
  components: {
    FooterToolBar
  },
  props: {
    record: {
      type: [String, Object],
      default: null
    },
    countries: {
      type: [Array],
      required: true
    }
  },
  data () {
    return {
      // 保存状态
      saving: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      editForm: this.$form.createForm(this),
      createFlag: false,
      // 加载中
      loading: true,
      // 州列表
      stateList: null
    }
  },
  mounted () {
    this.initData(this.record)
  },
  methods: {
    async initData (data) {
      this.loading = true
      var formData = null
      var createFlag = true
      const resCountry = await CountryApi.list()
      const countryList = resCountry.data
      this.countryList = countryList
      if (data === '') {
        const defaultCountryId = countryList[0].id
        const resStates = await StateApi.list(defaultCountryId)
        const stateList = resStates.data
        let defaultStateId = null
        if (stateList && stateList.length > 0) {
          defaultStateId = stateList[0].id
        }
        this.stateList = stateList
        // 新增
        formData = { 'id': null, 'code': null, 'nameEnUs': null, 'nameZhTw': null, 'nameZhCn': null, 'countryId': defaultCountryId, 'stateId': defaultStateId, 'sortNum': '0', 'enabledFlag': true }
      } else {
        createFlag = false
        const resStates = await StateApi.list(data.countryId)
        const stateList = resStates.data
        this.stateList = stateList
        // 编辑
        formData = pick(data, ['id', 'code', 'nameEnUs', 'nameZhTw', 'nameZhCn', 'countryId', 'stateId', 'sortNum', 'enabledFlag'])
        if (formData.enabledFlag !== null && formData.enabledFlag === '1') {
          formData.enabledFlag = true
        } else {
          formData.enabledFlag = false
        }
      }
      this.createFlag = createFlag
      this.editForm.setFieldsValue(formData)
      this.loading = false
    },
    loadAllDeptList () {
      return CityApi.query(Object.assign({ curPage: 1, pageSize: 1000 }, {}))
    },
    handleGoBack () {
      this.$emit('onGoBack')
    },
    // 处理国家选项变化
    async handelCountryChange (value) {
      const resState = await StateApi.list(value)
      const stateList = resState.data
      this.stateList = stateList
      if (stateList && stateList.length > 0) {
        this.$nextTick(() => {
          this.editForm.setFieldsValue({stateId: stateList[0].id})
        })
      } else {
        this.$nextTick(() => {
          this.editForm.setFieldsValue({stateId: null})
        })
      }
    },
    handleSubmit (e) {
      e.preventDefault()
      this.saving = true
      this.editForm.validateFields((err) => {
        // 如果校验失败直接返回
        if (err) {
          return
        }
        var formData = this.editForm.getFieldsValue()
        formData.enabledFlag = formData.enabledFlag ? '1' : '0'
        // 添加
        if (formData.id === null) {
          CityApi.add(formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Save successfully !')
              this.handleGoBack()
            }
          }).finally(() => {
            this.saving = false
          })
        }
        // 修改
        if (formData.id !== null) {
          CityApi.update(formData.id, formData).then(res => {
            if (!this.mixinProcessHasBizErrorNotification(res)) {
              this.mixinProcessSuccessNotification('Update successfully !')
              this.handleGoBack()
            }
          }).finally(() => {
            this.saving = false
          })
        }
      })
    }
  }
}
</script>
